module.exports = __webpack_public_path__ + "static/img/ezpay_logo.314663b6.svg";